// MIT License - Copyright (c) 2026 Doug McNall
import './Footer.css';
import { siteConfig } from '../config/siteConfig';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="footer_wrapper">
      <div className="footer_overlay"></div>
      <footer className="footer">
        <div className="footer_background" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/footer.jpg)` }}></div>
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="footer_content">
                <div className="footer_logo text-light">
                  <Link to="/shop">{siteConfig.company.name}</Link>
                </div>
                <div className="copyright text-light">
                  Copyright &copy;{new Date().getFullYear()} All rights reserved
                </div>
                <div className="footer_social text-light">
                  <ul>
                    <li>
                      <a 
                        href={siteConfig.social.pinterest} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        aria-label="Pinterest"
                      >
                        <i className="fa fa-pinterest" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a 
                        href={siteConfig.social.instagram} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                      >
                        <i className="fa fa-instagram" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a 
                        href={siteConfig.social.facebook} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                      >
                        <i className="fa fa-facebook" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a 
                        href={siteConfig.social.twitter} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        aria-label="Twitter"
                      >
                        <i className="fa fa-twitter" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
